module.exports = __webpack_public_path__ + "img/point-pro-3.edb6b0cf.png";